import React, { forwardRef } from 'react';
import { Text, TextProps } from '../Text';

/**
 * @deprecated use `HeadingText` from `genesis-core` instead
 */
export const HeadingOne = forwardRef<HTMLElement, TextProps>((props, ref) => (
  <Text
    as="h1"
    color="onSurface.text.primary"
    typography="headingOne"
    ref={ref}
    {...props}
  />
));

HeadingOne.displayName = 'HeadingOne';
